






























import { Vue, Component } from 'vue-property-decorator';
import { SwipeItem, Swipe, Icon, ImagePreview } from 'vant';
import { getDetail } from '../api';

Vue.use(Swipe).use(SwipeItem).use(Icon).use(ImagePreview);

@Component({})
export default class Detail extends Vue {
  detail: any = {};

  async created() {
    const ret = await getDetail(this.$route.query.id);
    this.detail = ret.data;
  }
  onSliderClick(imageList: any, index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: imageList, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
}
